<template>
  <div class="performanceStatistics column-me">
    <div class="tab-div row-me">
      <div class="item-tab column-me row-center" @click="clickTab(0)">
        <div class="tab-title" :class="{'tab-title-active':tabIndex===0}">员工工作量统计</div>
        <div class="tab-line" :class="{'tab-line-active':tabIndex===0}"></div>
      </div>
      <div class="item-tab column-me row-center" @click="clickTab(1)">
        <div class="tab-title" :class="{'tab-title-active':tabIndex===1}">煎药机工作量统计</div>
        <div class="tab-line" :class="{'tab-line-active':tabIndex===1}"></div>
      </div>
      <div class="item-tab column-me row-center" @click="clickTab(2)">
        <div class="tab-title" :class="{'tab-title-active':tabIndex===2}">包装机工作量统计</div>
        <div class="tab-line" :class="{'tab-line-active':tabIndex===2}"></div>
      </div>
    </div>
    <!-- 员工工作量统计 -->
    <div class="card-div column-me flex1" v-show="tabIndex===0">
      <div class="row-me row-center">
        <div class="width180">
          <el-date-picker type="date" placeholder="开始时间" value-format="YYYY-MM-DD" style="width: 100%;"
                          v-model="tab1Item.selectDate1" :disabled-date="disabledDate">
          </el-date-picker>
        </div>
        <div class="margin-left10 margin-right10">-</div>
        <div class="width180 margin-right10">
          <el-date-picker type="date" placeholder="结束时间" value-format="YYYY-MM-DD" style="width: 100%;"
                          v-model="tab1Item.selectDate2" :disabled-date="disabledDate">
          </el-date-picker>
        </div>
        <div class="width180 margin-right10">
          <el-input placeholder="员工姓名" style="width: 100%;" clearable v-model="tab1Item.name"></el-input>
        </div>
        <div class="width180 margin-right10">
          <el-select placeholder="工作内容" style="width: 100%;" filterable clearable v-model="tab1Item.selectContent">
            <el-option v-for="item in contentArray" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </div>
        <div class="btn-blue width100 btn-height40" @click="clickSearch">
          <el-icon>
            <search/>
          </el-icon>
          查询
        </div>
        <div class="btn-blank width100 btn-height40 margin-left10" @click="clickClear">
          <el-icon>
            <delete/>
          </el-icon>
          清空
        </div>
        <div class="btn-blank width100 btn-height40 margin-left10" @click="clickExport">导出</div>
      </div>
      <div class="margin-top20">
        <el-table :data="tab1Item.tableData" border header-cell-class-name="table-header-style"
                  cell-class-name="table-cell-style">
          <el-table-column type="index" label="序号" width="80" align="center"/>
          <el-table-column prop="name" label="员工姓名" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="departmentName" label="部门" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="content" label="工作内容" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="prescriptionNums" label="处方数" align="center"
                           show-overflow-tooltip></el-table-column>
          <el-table-column prop="typeNums" label="剂数" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="drugNums" label="药材味数" align="center" show-overflow-tooltip></el-table-column>
        </el-table>
      </div>
      <div class="margin-top10">
        <el-pagination @current-change="handleCurrentChange1" :current-page.sync="tab1Item.pageNo"
                       layout="total, prev, pager, next, jumper" :total="tab1Item.total">
        </el-pagination>
      </div>
    </div>

    <!-- 煎药机工作量统计 -->
    <div class="card-div column-me flex1" v-show="tabIndex===1">
      <div class="row-me row-center">
        <div class="width180">
          <el-date-picker type="date" placeholder="开始时间" value-format="YYYY-MM-DD" style="width: 100%;"
                          v-model="tab2Item.selectDate1" :disabled-date="disabledDate">
          </el-date-picker>
        </div>
        <div class="margin-left10 margin-right10">-</div>
        <div class="width180 margin-right10">
          <el-date-picker type="date" placeholder="结束时间" value-format="YYYY-MM-DD" style="width: 100%;"
                          v-model="tab2Item.selectDate2" :disabled-date="disabledDate">
          </el-date-picker>
        </div>
        <div class="width180 margin-right10">
          <el-input placeholder="煎药机号" style="width: 100%;" clearable v-model="tab2Item.number"></el-input>
        </div>
        <div class="width180 margin-right10" v-if="false">
          <el-select placeholder="工作内容" style="width: 100%;" filterable clearable v-model="tab2Item.selectContent">
            <el-option v-for="item in contentArray" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </div>
        <div class="btn-blue width100 btn-height40" @click="clickSearch">
          <el-icon>
            <search/>
          </el-icon>
          查询
        </div>
        <div class="btn-blank width100 btn-height40 margin-left10" @click="clickClear">
          <el-icon>
            <delete/>
          </el-icon>
          清空
        </div>
        <div class="btn-blank width100 btn-height40 margin-left10" @click="clickExport">导出</div>
      </div>
      <div class="margin-top20">
        <el-table :data="tab2Item.tableData" border header-cell-class-name="table-header-style"
                  cell-class-name="table-cell-style">
          <el-table-column prop="day" label="日期" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="name" label="煎药机号" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="content" label="工作内容" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="nums" label="工作量" align="center" show-overflow-tooltip></el-table-column>
        </el-table>
      </div>
      <div class="margin-top10">
        <el-pagination @current-change="handleCurrentChange2" :current-page.sync="tab2Item.pageNo"
                       layout="total, prev, pager, next, jumper" :total="tab2Item.total">
        </el-pagination>
      </div>
    </div>

    <!-- 包装机工作量统计 -->
    <div class="card-div column-me flex1" v-show="tabIndex===2">
      <div class="row-me row-center">
        <div class="width180">
          <el-date-picker type="date" placeholder="开始时间" value-format="YYYY-MM-DD" style="width: 100%;"
                          v-model="tab3Item.selectDate1" :disabled-date="disabledDate">
          </el-date-picker>
        </div>
        <div class="margin-left10 margin-right10">-</div>
        <div class="width180 margin-right10">
          <el-date-picker type="date" placeholder="结束时间" value-format="YYYY-MM-DD" style="width: 100%;"
                          v-model="tab3Item.selectDate2" :disabled-date="disabledDate">
          </el-date-picker>
        </div>
        <div class="width180 margin-right10">
          <el-input placeholder="包装机号" style="width: 100%;" clearable v-model="tab3Item.number"></el-input>
        </div>
        <div class="width180 margin-right10" v-if="false">
          <el-select placeholder="工作内容" style="width: 100%;" filterable clearable v-model="tab3Item.selectContent">
            <el-option v-for="item in contentArray" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </div>
        <div class="btn-blue width100 btn-height40" @click="clickSearch">
          <el-icon>
            <search/>
          </el-icon>
          查询
        </div>
        <div class="btn-blank width100 btn-height40 margin-left10" @click="clickClear">
          <el-icon>
            <delete/>
          </el-icon>
          清空
        </div>
        <div class="btn-blank width100 btn-height40 margin-left10" @click="clickExport">导出</div>
      </div>
      <div class="margin-top20">
        <el-table :data="tab3Item.tableData" border header-cell-class-name="table-header-style"
                  cell-class-name="table-cell-style">
          <el-table-column prop="day" label="日期" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="name" label="包装机号" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="content" label="工作内容" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="nums" label="工作量" align="center" show-overflow-tooltip></el-table-column>
        </el-table>
      </div>
      <div class="margin-top10">
        <el-pagination @current-change="handleCurrentChange3" :current-page.sync="tab3Item.pageNo"
                       layout="total, prev, pager, next, jumper" :total="tab3Item.total">
        </el-pagination>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  components: {},
  data() {
    let that = this
    return {
      tabIndex: 0,
      contentArray: ['接方', '审方', '复核', '调剂', '煎药', '泡药', '包装', '发货'],
      tab1Item: {
        selectDate1: '',
        selectDate2: '',
        name: '',
        selectContent: '',
        tableData: [],
        pageNo: 1,
        total: 0,
      },
      tab2Item: {
        selectDate1: '',
        selectDate2: '',
        number: '',
        selectContent: '',
        tableData: [],
        pageNo: 1,
        total: 0,
      },
      tab3Item: {
        selectDate1: '',
        selectDate2: '',
        number: '',
        selectContent: '',
        tableData: [],
        pageNo: 1,
        total: 0,
      },
      disabledDate: function (time) {
        return time.getTime() > new Date(that.$method.getNowTime()).getTime();
      },
    }
  },
  // html加载完成之前
  created() {
    this.tab1Item.selectDate1 = this.$method.getNowDate()
    this.tab1Item.selectDate2 = this.$method.getNowDate()
    this.tab2Item.selectDate1 = this.$method.getNowDate()
    this.tab2Item.selectDate2 = this.$method.getNowDate()
    this.tab3Item.selectDate1 = this.$method.getNowDate()
    this.tab3Item.selectDate2 = this.$method.getNowDate()
  },
  // html加载完成后执行。
  mounted() {
    this.getData()
  },
  // 事件方法执行
  methods: {
    //获取数据
    getData() {
      if (this.tabIndex === 0) {
        this.$postFormRequest('/admin/saleSettlement/performanceSettlement', {
          start: this.tab1Item.selectDate1,
          end: this.tab1Item.selectDate2,
          name: this.tab1Item.name,
          content: this.tab1Item.selectContent,
          pageNumber: this.tab1Item.pageNo,
        }).then((res) => {
          if (res) {
            this.tab1Item.tableData = res.data.list
            this.tab1Item.total = res.data.totalRow
          }
        }).catch((error) => {
          console.log(error)
        })
      } else if (this.tabIndex === 1) {
        this.$postFormRequest('/admin/saleSettlement/equipmentStatement', {
          start: this.tab2Item.selectDate1,
          end: this.tab2Item.selectDate2,
          sn: this.tab2Item.number,
          content: this.tab2Item.selectContent,
          type: 1,//1煎药机，2包装机
          pageNumber: this.tab2Item.pageNo,
        }).then((res) => {
          if (res) {
            this.tab2Item.tableData = res.data.list
            this.tab2Item.total = res.data.totalRow
          }
        }).catch((error) => {
          console.log(error)
        })
      } else if (this.tabIndex === 2) {
        this.$postFormRequest('/admin/saleSettlement/equipmentStatement', {
          start: this.tab3Item.selectDate1,
          end: this.tab3Item.selectDate2,
          sn: this.tab3Item.number,
          content: this.tab3Item.selectContent,
          type: 2,//1煎药机，2包装机
          pageNumber: this.tab3Item.pageNo,
        }).then((res) => {
          if (res) {
            this.tab3Item.tableData = res.data.list
            this.tab3Item.total = res.data.totalRow
          }
        }).catch((error) => {
          console.log(error)
        })
      }
    },
    clickTab(index) {
      this.tabIndex = index
      this.getData()
    },
    clickSearch() {
      if (this.tabIndex === 0) {
        if (this.tab1Item.selectDate1 > this.tab1Item.selectDate2) {
          this.$message.error('开始时间不能大于结束时间')
          return
        }
        this.tab1Item.pageNo = 1
      } else if (this.tabIndex === 1) {
        if (this.tab2Item.selectDate1 > this.tab2Item.selectDate2) {
          this.$message.error('开始时间不能大于结束时间')
          return
        }
        this.tab2Item.pageNo = 1
      } else if (this.tabIndex === 2) {
        if (this.tab3Item.selectDate1 > this.tab3Item.selectDate2) {
          this.$message.error('开始时间不能大于结束时间')
          return
        }
        this.tab3Item.pageNo = 1
      }
      this.getData()
    },
    clickClear() {
      if (this.tabIndex === 0) {
        this.tab1Item.selectDate1 = this.$method.getNowDate()
        this.tab1Item.selectDate2 = this.$method.getNowDate()
        this.tab1Item.name = ''
        this.tab1Item.selectContent = ''
      } else if (this.tabIndex === 1) {
        this.tab2Item.selectDate1 = this.$method.getNowDate()
        this.tab2Item.selectDate2 = this.$method.getNowDate()
        this.tab2Item.number = ''
        this.tab2Item.selectContent = ''
      } else if (this.tabIndex === 2) {
        this.tab3Item.selectDate1 = this.$method.getNowDate()
        this.tab3Item.selectDate2 = this.$method.getNowDate()
        this.tab3Item.number = ''
        this.tab3Item.selectContent = ''
      }
      this.getData()
    },
    clickExport() {
      let token = sessionStorage.getItem('token')
      let url = ''
      if (this.tabIndex === 0) {
        let param = {
          start: this.tab1Item.selectDate1,
          end: this.tab1Item.selectDate2,
          name: this.tab1Item.name,
          content: this.tab1Item.selectContent,
          pageNumber: this.tab1Item.pageNo,
          token: token,
        }
        url = this.$baseUrl + '/admin/saleSettlement/performanceSettlementExport?' + this.$method.getParamsString(param)
      } else if (this.tabIndex === 1) {
        let param = {
          start: this.tab2Item.selectDate1,
          end: this.tab2Item.selectDate2,
          sn: this.tab2Item.number,
          content: this.tab2Item.selectContent,
          type: 1,//1煎药机，2包装机
          pageNumber: this.tab2Item.pageNo,
          token: token,
        }
        url = this.$baseUrl + '/admin/saleSettlement/equipmentStatementExport?' + this.$method.getParamsString(param)
      } else if (this.tabIndex === 2) {
        let param = {
          start: this.tab3Item.selectDate1,
          end: this.tab3Item.selectDate2,
          sn: this.tab3Item.number,
          content: this.tab3Item.selectContent,
          type: 2,//1煎药机，2包装机
          pageNumber: this.tab3Item.pageNo,
          token: token,
        }
        url = this.$baseUrl + '/admin/saleSettlement/equipmentStatementExport?' + this.$method.getParamsString(param)
      }
      window.open(url)
    },
    //页数改变
    handleCurrentChange1(pageNo) {
      this.tab1Item.pageNo = pageNo
      this.getData()
    },
    handleCurrentChange2(pageNo) {
      this.tab2Item.pageNo = pageNo
      this.getData()
    },
    handleCurrentChange3(pageNo) {
      this.tab3Item.pageNo = pageNo
      this.getData()
    },
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
}
</script>

<style lang="scss" scoped>
.performanceStatistics {
  height: 100%;

  .tab-div {
    height: 60px;
    background: #FFFFFF;
    margin: 20px 20px 0 20px;
    padding-left: 20px;

    .item-tab {
      height: 60px;
      justify-content: flex-end;
      margin-right: 50px;

      .tab-title {
        font-size: 18px;
        color: #252630;

        &-active {
          color: #215AA0;
        }
      }

      .tab-line {
        width: 20px;
        height: 4px;
        background: #FFFFFF;
        border-radius: 1px;

        &-active {
          background: #215AA0;
        }
      }
    }
  }

  .card-div {
    margin: 20px;
    background: #FFFFFF;
    box-shadow: 0 0 5px #F3F3F3;
    border-radius: 3px;
    padding: 20px;
    font-size: 18px;
    color: #252630;
    overflow: auto;
  }
}
</style>
